/**
 * Created by jerry on 2017/11/13.
 * 用户相关api
 */
import * as API from './'

export default {
   //导出excel的一些get请求
   excelOut: (url, params) => {
    return API.GET(url, params)
  },
  //登录
  login: params => {
    return API.POST('/manager/pc_login', params)
  },
  //发送验证码
  loginSendCode: params => {
    return API.POST('/manager/user/pc_login_send_code', params)
  },
  //验证码登录
  loginSecond: params => {
    return API.POST('/manager/user/pc_login_second', params)
  },
  //商品分类列表
  good_type_list: params => {
    return API.POST('/manager/user/good_type_list', params)
  },
  //登出
  logout: params => {
    return API.POST('/manager/logout', params)
  },
  back_music_list: params => {
    return API.POST('/manager/user/pc/back_music_list', params)
  },
  add_back_music: params => {
    return API.POST('/manager/user/pc/add_back_music', params)
  },
  del_back_music: params => {
    return API.POST('/manager/user/pc/del_back_music', params)
  },
   //查询打卡积分列表
   user_card_score_list: params => {
    return API.POST('/manager/user/pc/user_card_score_list', params)
  },
  //商品二分类列表
  good_second_type_list: params => {
    return API.POST('/manager/user/pc/good_second_type_list', params)
  },
  //商品大分类列表
  good_first_type_list: params => {
    return API.POST('/manager/user/pc/good_first_type_list', params)
  },


  check_send_thing_list: params => {
    return API.POST('/manager/user/pc/check_send_thing_list', params)
  },

  feed_back_list: params => {
    return API.POST('/manager/user/pc/feed_back_list', params)
  },

  up_role_list: params => {
    return API.POST('/manager/user/pc/up_role_list', params)
  },

  rule_province_list: params => {
    return API.POST('/manager/user/pc/rule_province_list', params)
  },

  score_user_list: params => {
    return API.POST('/manager/user/pc/score_user_list', params)
  },

  up_up_role: params => {
    return API.POST('/manager/user/pc/up_up_role', params)
  },

  up_up_role_de_con: params => {
    return API.POST('/manager/user/pc/up_up_role_de_con', params)
  },


  hot_word_list: params => {
    return API.POST('/manager/user/pc/hot_word_list', params)
  },
  add_hot_word: params => {
    return API.POST('/manager/user/pc/add_hot_word', params)
  },
  del_hot_word: params => {
    return API.POST('/manager/user/pc/del_hot_word', params)
  },
  push_hot_word: params => {
    return API.POST('/manager/user/pc/push_hot_word', params)
  },
  down_hot_word: params => {
    return API.POST('/manager/user/pc/down_hot_word', params)
  },

  up_dic_data: params => {
    return API.POST('/manager/user/pc/up_dic_data', params)
  },

  app_user_tonglian_balance_list_excel: params => {
    return API.GET('/manager/user/pc/app_user_tonglian_balance_list_excel', params)
  },

  dic_data: params => {
    return API.POST('/manager/user/pc/dic_data', params)
  },

  bank_list: params => {
    return API.POST('/manager/user/pc/bank_list', params)
  },

  seven_token: params => {
    return API.POST('/manager/user/seven_token', params)
  },

  pos_list: params => {
    return API.POST('/manager/user/pc/pos_list', params)
  },
  add_pos: params => {
    return API.POST('/manager/user/pc/add_pos', params)
  },
  add_bank: params => {
    return API.POST('/manager/user/pc/add_bank', params)
  },
  error_log_detail: params => {
    return API.POST('/manager/user/pc/error_log_detail', params)
  },
  del_bank: params => {
    return API.POST('/manager/user/pc/del_bank', params)
  },
  push_bank: params => {
    return API.POST('/manager/user/pc/push_bank', params)
  },
  down_bank: params => {
    return API.POST('/manager/user/pc/down_bank', params)
  },
  app_send_good: params => {
    return API.POST('/manager/user/pc/app_send_good', params)
  },
  H5_app_send_good: params => {
    return API.POST('manager/user/pc/h5_setter_remark', params)
  },
  h5_company_list: params => {
    return API.POST('manager/user/pc/h5_company_list', params)
  },
  setter_remark: params => {
    return API.POST('/manager/user/pc/setter_remark', params)
  },

  judge_list: params => {
    return API.POST('/manager/user/pc/judge_list', params)
  },
  up_charge: params => {
    return API.POST('/manager/user/pc/up_charge', params)
  },
  check_add_user_stock_list: params => {
    return API.POST('/manager/user/pc/check_add_user_stock_list', params)
  },
  check_add_user_stock: params => {
    return API.POST('/manager/user/pc/check_add_user_stock', params)
  },
  score_up_cash_out: params => {
    return API.POST('/manager/user/pc/score_up_cash_out', params)
  },


  direct_score_month_data_detail: params => {
    return API.POST('/manager/user/pc/direct_score_month_data_detail', params)
  },
  direct_score_month_data: params => {
    return API.POST('/manager/user/pc/direct_score_month_data', params)
  },
  group_score_month_data_detail: params => {
    return API.POST('/manager/user/pc/group_score_month_data_detail', params)
  },
  group_score_month_data: params => {
    return API.POST('/manager/user/pc/group_score_month_data', params)
  },

  up_cash_out: params => {
    return API.POST('/manager/user/pc/up_cash_out', params)
  },
  second_up_cash_out: params => {
    return API.POST('/manager/user/pc/second_up_cash_out', params)
  },

  money_in_list: params => {
    return API.POST('/manager/user/pc/money_in_list', params)
  },

  plat_money_record_list: params => {
    return API.POST('/manager/user/pc/plat_money_record_list', params)
  },
  op_bu_order_list: params => {
    return API.POST('/manager/user/pc/op_bu_order_list', params)
  },
  check_op_bu_order: params => {
    return API.POST('/manager/user/pc/check_op_bu_order', params)
  },



  send_ac_list: params => {
    return API.POST('/manager/user/pc/send_ac_list', params)
  },
  do_up_send_ac: params => {
    return API.POST('/manager/user/pc/do_up_send_ac', params)
  },
  get_all_good_name: params => {
    return API.POST('/manager/user/pc/get_all_good_name', params)
  },
  del_send_ac: params => {
    return API.POST('/manager/user/pc/del_send_ac', params)
  },


  op_deposit: params => {
    return API.POST('/manager/user/pc/op_deposit', params)
  },

  change_tong_info: params => {
    return API.POST('/manager/user/pc/change_tong_info', params)
  },


  op_deposit_list: params => {
    return API.POST('/manager/user/pc/op_deposit_list', params)
  },
  check_op_deposit: params => {
    return API.POST('/manager/user/pc/check_op_deposit', params)
  },
  score_money_out_list: params => {
    return API.POST('/manager/user/pc/score_money_out_list', params)
  },

  on_line_pay_list: params => {
    return API.POST('/manager/user/pc/on_line_pay_list', params)
  },
  score_second_up_cash_out: params => {
    return API.POST('/manager/user/pc/score_second_up_cash_out', params)
  },

  in_user_num_list: params => {
    return API.POST('/manager/user/pc/in_user_num_list', params)
  },

  ceo_num_list: params => {
    return API.POST('/manager/user/pc/ceo_num_list', params)
  },

  user_money_data: params => {
    return API.POST('/manager/user/pc/user_money_data', params)
  },

  good_fake_sale_list_data: params => {
    return API.POST('/manager/user/pc/good_fake_sale_list_data', params)
  },

  good_fake_sale_data: params => {
    return API.POST('/manager/user/pc/good_fake_sale_data', params)
  },

  good_real_sale_data: params => {
    return API.POST('/manager/user/pc/good_real_sale_data', params)
  },

  good_sale_count: params => {
    return API.POST('/manager/user/pc/good_sale_count', params)
  },
  sale_good_record_count: params => {
    return API.POST('/manager/user/pc/sale_good_record_count', params)
  },

  group_count_list: params => {
    return API.POST('/manager/user/pc/group_count_list', params)
  },

  group_count_total: params => {
    return API.POST('/manager/user/pc/group_count_total', params)
  },

  user_arc_info: params => {
    return API.POST('/manager/user/pc/user_arc_info', params)
  },

  user_follow_list: params => {
    return API.POST('/manager/user/pc/user_follow_list', params)
  },

  pay_out_list: params => {
    return API.POST('/manager/user/pc/pay_out_list', params)
  },
  trial_list: params => {
    return API.POST('/manager/user/pc/trial_list', params)
  },

  reward_list: params => {
    return API.POST('/manager/user/pc/reward_list', params)
  },
  sale_count_list: params => {
    return API.POST('/manager/user/pc/sale_count_list', params)
  },
  sale_count_total: params => {
    return API.POST('/manager/user/pc/sale_count_total', params)
  },

  red_change_money_list: params => {
    return API.POST('/manager/user/pc/red_change_money_list', params)
  },
  change_money_list: params => {
    return API.POST('/manager/user/pc/change_money_list', params)
  },

  money_out_list: params => {
    return API.POST('/manager/user/pc/money_out_list', params)
  },
  check_app_user_balance: params => {
    return API.POST('/manager/user/pc/check_app_user_balance', params)
  },
  change_balance_list: params => {
    return API.POST('/manager/user/pc/change_balance_list', params)
  },
  up_add_score_rank: params => {
    return API.POST('/manager/user/pc/up_add_score_rank', params)
  },
  status_score_rank: params => {
    return API.POST('/manager/user/pc/status_score_rank', params)
  },
  score_rank_list: params => {
    return API.POST('/manager/user/pc/score_rank_list', params)
  },

  search_shop_list: params => {
    return API.POST('/manager/user/pc/search_shop_list', params)
  },
  down_file_list: params => {
    return API.POST('/manager/user/pc/down_file_list', params)
  },
  del_judge: params => {
    return API.POST('/manager/user/pc/del_judge', params)
  },
  push_judge: params => {
    return API.POST('/manager/user/pc/push_judge', params)
  },
  status_recommend_judge: params => {
    return API.POST('/manager/user/pc/status_recommend_judge', params)
  },
  down_judge: params => {
    return API.POST('/manager/user/pc/down_judge', params)
  },


  add_edit_course: params => {
    return API.POST('/manager/user/pc/add_edit_course', params)
  },

  del_course: params => {
    return API.POST('/manager/user/pc/del_course', params)
  },

  push_course: params => {
    return API.POST('/manager/user/pc/push_course', params)
  },

  down_course: params => {
    return API.POST('/manager/user/pc/down_course', params)
  },

  course_list: params => {
    return API.POST('/manager/user/pc/course_list', params)
  },

  finish_work_list: params => {
    return API.POST('/manager/user/pc/finish_work_list', params)
  },





  add_reco: params => {
    return API.POST('/manager/user/pc/add_reco', params)
  },
  up_log_list: params => {
    return API.POST('/manager/user/pc/up_log_list', params)
  },

  normal_user_stock_detail: params => {
    return API.GET('/manager/user/pc/normal_user_stock_detail',params)
  },
  normal_user_stock_detail_value: params => {
    return API.GET('/manager/user/pc/normal_user_stock_detail_value',params)
  },
  normal_user_stock_excel: params => {
    return  API.GET('/manager/user/pc/normal_user_stock_excel',params)
  },

  stock_value_excel: params => {
    return API.GET('/manager/user/pc/stock_value_excel',params)
  },

  area_ac_info_list: params => {
    return API.POST('/manager/user/pc/area_ac_info_list', params)
  },

  card_score_record_list: params => {
    return API.POST('/manager/user/pc/card_score_record_list', params)
  },
  stu_course_user_list: params => {
    return API.POST('/manager/user/pc/stu_course_user_list', params)
  },
  bu_order_out_list: params => {
    return API.POST('/manager/user/pc/bu_order_out_list', params)
  },
  get_money_record_list: params => {
    return API.POST('/manager/user/pc/get_money_record_list', params)
  },
  head_invite_user: params => {
    return API.POST('/manager/user/pc/head_invite_user', params)
  },
  send_order_list: params => {
    return API.POST('/manager/user/pc/send_order_list', params)
  },
  deposit_data: params => {
    return API.POST('/manager/user/pc/deposit_data', params)
  },
  good_sale_list: params => {
    return API.POST('/manager/user/pc/good_sale_list', params)
  },
  get_sale_num_list: params => {
    return API.POST('/manager/user/pc/get_sale_num_list', params)
  },
  top_user_list: params => {
    return API.POST('/manager/user/pc/top_user_list', params)
  },
  send_head_num: params => {
    return API.POST('/manager/user/pc/send_head_num', params)
  },
  send_head_num_GD: params => {
    return API.POST('/manager/user/pc/send_head_num_GD',params)
  },
  up_group_in: params => {
    return API.POST('/manager/user/pc/up_group_in', params)
  },
  edit_deposit_need: params => {
    return API.POST('/manager/user/pc/edit_deposit_need', params)
  },
  set_group_type: params => {
    return API.POST('/manager/user/pc/set_group_type', params)
  },
  set_ceo: params => {
    return API.POST('/manager/user/pc/set_ceo', params)
  },
  edit_up_recommend: params => {
    return API.POST('/manager/user/pc/edit_up_recommend', params)
  },
  change_up_lin: params => {
    return API.POST('/manager/user/pc/change_up_lin', params)
  },
  get_province_list: params => {
    return API.POST('/manager/user/pc/get_province_list', params)
  },
  setDistrictM: params => {
    return API.POST('/manager/user/pc/setDistrictM', params)
  },
  getDisManager: params => {
    return API.POST('/manager/user/pc/getDisManager', params)
  },



  set_sale_top: params => {
    return API.POST('/manager/user/pc/set_sale_top', params)
  },
  sale_user_list: params => {
    return API.POST('/manager/user/pc/sale_user_list', params)
  },
  getSaleManager: params => {
    return API.POST('/manager/user/pc/getSaleManager', params)
  },



  change_app_user_balance: params => {
    return API.POST('/manager/user/pc/change_app_user_balance', params)
  },

  add_edit_rule_province: params => {
    return API.POST('/manager/user/pc/add_edit_rule_province', params)
  },


  select_province_list: params => {
    return API.POST('/manager/user/pc/select_province_list', params)
  },
  del_reco: params => {
    return API.POST('/manager/user/pc/del_reco', params)
  },
  reco_list: params => {
    return API.POST('/manager/user/pc/reco_list', params)
  },
  push_reco: params => {
    return API.POST('/manager/user/pc/push_reco', params)
  },
  down_reco: params => {
    return API.POST('/manager/user/pc/down_reco', params)
  },

  property_name_list: params => {
    return API.POST('/manager/user/pc/property_name_list', params)
  },
  status_property_name: params => {
    return API.POST('/manager/user/pc/status_property_name', params)
  },

  selectGoodGuides: params => {
    return API.POST('/manager/user/pc/selectGoodGuides', params)
  },


  up_add_good_sku: params => {
    return API.POST('/manager/user/pc/up_add_good_sku', params)
  },

  good_list: params => {
    return API.POST('/manager/user/pc/good_list', params)
  },
  up_add_good: params => {
    return API.POST('/manager/user/pc/up_add_good', params)
  },
  get_all_types: params => {
    return API.POST('/manager/user/pc/get_all_types', params)
  },
  get_group_user_info: params => {
    return API.POST('/manager/user/pc/get_group_user_info', params)
  },
  get_group_user_t_ba: params => {
    return API.POST('/manager/user/pc/get_group_user_t_ba', params)
  },
  get_group_user_t_info: params => {
    return API.POST('/manager/user/pc/get_group_user_t_info', params)
  },
  get_tou_cun: params => {
    return API.POST('/manager/user/pc/get_tou_cun', params)
  },
  status_good: params => {
    return API.POST('/manager/user/pc/status_good', params)
  },
  status_province_up: params => {
    return API.POST('/manager/user/pc/status_province_up', params)
  },
  status_loc_up: params => {
    return API.POST('/manager/user/pc/status_loc_up', params)
  },
  status_index_good: params => {
    return API.POST('/manager/user/pc/status_index_good', params)
  },

  status_index_good_type: params => {
    return API.POST('/manager/user/pc/status_index_good_type', params)
  },


  service_order_list: params => {
    return API.POST('/manager/user/pc/service_order_list', params)
  },
  close_service_order: params => {
    return API.POST('/manager/user/pc/close_service_order', params)
  },


  complain_list: params => {
    return API.POST('/manager/user/pc/complain_list', params)
  },
  complain_detail: params => {
    return API.POST('/manager/user/pc/complain_detail', params)
  },
  status_complain: params => {
    return API.POST('/manager/user/pc/status_complain', params)
  },
  give_complain: params => {
    return API.POST('/manager/user/pc/give_complain', params)
  },

  manager_user_list: params => {
    return API.POST('/manager/user/pc/manager_user_list', params)
  },
  add_up_manager_user: params => {
    return API.POST('/manager/user/pc/add_up_manager_user', params)
  },
  edit_manager_user_role: params => {
    return API.POST('/manager/user/pc/edit_manager_user_role', params)
  },
  status_manager_user: params => {
    return API.POST('/manager/user/pc/status_manager_user', params)
  },
  edit_manager_pass: params => {
    return API.POST('/manager/user/pc/edit_manager_pass', params)
  },

  //上架、下架、删除分类
  up_check_role: params => {
    return API.POST('/manager/user/pc/up_check_role', params)
  },

  check_rule_list: params => {
    return API.POST('/manager/user/pc/check_rule_list', params)
  },
  lock_user_list: params => {
    return API.POST('/manager/user/pc/lock_user_list', params)
  },
  check_record_list: params => {
    return API.POST('/manager/user/pc/check_record_list', params)
  },

  my_score_list: params => {
    return API.POST('/manager/user/pc/my_score_list', params)
  },
  si_pay_list: params => {
    return API.POST('/manager/user/pc/si_pay_list', params)
  },

  del_check_rule: params => {
    return API.POST('/manager/user/pc/del_check_rule', params)
  },



  status_good_content: params => {
    return API.POST('/manager/user/pc/status_good_content', params)
  },
  add_good_content: params => {
    return API.POST('/manager/user/pc/add_good_content', params)
  },
  good_content_list: params => {
    return API.POST('/manager/user/pc/good_content_list', params)
  },


  //上架、下架、删除分类
  status_good_type: params => {
    return API.POST('/manager/user/pc/status_good_type', params)
  },
  normal_user_list: params => {
    return API.POST('/manager/user/pc/app_user_list', params)
  },
  my_inner_score: params => {
    return API.POST('/manager/user/pc/my_inner_score', params)
  },
  score_record_detail: params => {
    return API.POST('/manager/user/pc/score_record_detail', params)
  },
  score_record_list: params => {
    return API.POST('/manager/user/pc/score_record_list', params)
  },
  shop_list: params => {
    return API.POST('/manager/user/pc/shop_list', params)
  },
  district_list: params => {
    return API.POST('/manager/user/pc/district_list', params)
  },


  give_area_list: params => {
    return API.POST('/manager/user/pc/give_area_list', params)
  },
  release_money: params => {
    return API.POST('/manager/user/pc/release_money', params)
  },

  up_shop_show: params => {
    return API.POST('/manager/user/pc/up_shop_show', params)
  },
  user_bank_list: params => {
    return API.POST('/manager/user/pc/user_bank_list', params)
  },
  user_address_list: params => {
    return API.POST('/manager/user/pc/user_address_list', params)
  },
  get_group_user_count: params => {
    return API.POST('/manager/user/pc/get_group_user_count', params)
  },
  order_list: params => {
    return API.POST('/manager/user/pc/order_list', params)
  },
  h5_order_count: params => {
    return API.POST('/manager/user/pc/h5_order_count', params)
  },
  h5_order_list: params => {
    return API.POST('/manager/user/pc/h5_order_list', params)
  },
  order_money: params => {
    return API.POST('/manager/user/pc/order_money', params)
  },
  status_normal_user: params => {
    return API.POST('/manager/user/pc/status_app_user', params)
  },
  again_real_apply: params => {
    return API.POST('/manager/user/pc/again_real_apply', params)
  },
  out_total_p: params => {
    return API.POST('/manager/user/pc/out_total_p', params)
  },
  set_del_app_user: params => {
    return API.POST('/manager/user/pc/set_del_app_user', params)
  },
  back_del_app_user: params => {
    return API.POST('/manager/user/pc/back_del_app_user', params)
  },
  set_exec_province: params => {
    return API.POST('/manager/user/pc/set_exec_province', params)
  },
  up_province_type: params => {
    return API.POST('/manager/user/pc/up_province_type', params)
  },
  set_p_to_ceo: params => {
    return API.POST('/manager/user/pc/set_p_to_ceo', params)
  },
  op_bu_order: params => {
    return API.POST('/manager/user/pc/op_bu_order', params)
  },
  good_order_detail: params => {
    return API.POST('/manager/user/pc/good_order_detail', params)
  },
  h5_good_order_detail: params => {
    return API.POST('/manager/user/pc/h5_order_detail', params)
  },
  h5_good_order_detail_print: params => {
    return API.POST('manager/user/pc/h5_good_order_detail_print', params)
  },
  apply_return: params => {
    return API.POST('/manager/user/pc/apply_return', params)
  },
  reset_group_pass: params => {
    return API.POST('/manager/user/pc/reset_group_pass', params)
  },
  import_car_info: (params, config) => {
    return API.POSTFile('/manager/user/pc/import_car_info', params, config)
  },
  send_good: params => {
    return API.POST('/manager/user/pc/send_good', params)
  },
  banner_add: params => {
    return API.POST('/manager/user/pc/banner_add', params)
  },
  add_edit_app_user: params => {
    return API.POST('/manager/user/pc/add_edit_app_user', params)
  },
  do_up_role_up: params => {
    return API.POST('/manager/user/pc/do_up_role_up', params)
  },
  down_user_role: params => {
    return API.POST('/manager/user/pc/down_user_role', params)
  },
  do_out_user: params => {
    return API.POST('/manager/user/pc/do_out_user', params)
  },
  get_province: params => {
    return API.POST('/manager/user/pc/get_province', params)
  },
  get_area_data: params => {
    return API.POST('/manager/user/pc/get_area_data', params)
  },
  get_city: params => {
    return API.POST('/manager/user/pc/get_city', params)
  },
  select_address_by_word: params => {
    return API.POST('/manager/user/pc/select_address_by_word', params)
  },
  get_district: params => {
    return API.POST('/manager/user/pc/get_district', params)
  },
  up_add_good_type: params => {
    return API.POST('/manager/user/pc/up_add_good_type', params)
  },
  up_add_property_name: params => {
    return API.POST('/manager/user/pc/up_add_property_name', params)
  },
  banner_list: params => {
    return API.POST('/manager/user/pc/banner_list', params)
  },
  banner_delete: params => {
    return API.POST('/manager/user/pc/banner_delete', params)
  },

  push_plat_notice: params => {
    return API.POST('/manager/user/pc/push_plat_notice', params)
  },
  del_plat_notice: params => {
    return API.POST('/manager/user/pc/del_plat_notice', params)
  },
  add_up_plat_notice: params => {
    return API.POST('/manager/user/pc/add_up_plat_notice', params)
  },
  plat_notice_list: params => {
    return API.POST('/manager/user/pc/plat_notice_list', params)
  },

  banner_get: params => {
    return API.POST('/manager/user/pc/banner_get', params)
  },

  property_value_list: params => {
    return API.POST('/manager/user/pc/property_value_list', params)
  },
  up_add_property_value: params => {
    return API.POST('/manager/user/pc/up_add_property_value', params)
  },
  status_property_value: params => {
    return API.POST('/manager/user/pc/status_property_value', params)
  },

  dic_content: params => {
    return API.POST('/manager/user/pc/dic_content', params)
  },
  edit_dic_content: params => {
    return API.POST('/manager/user/pc/edit_dic_content', params)
  },

  help_add: params => {
    return API.POST('/manager/pc/help_add', params)
  },
  help_get: params => {
    return API.POST('/manager/pc/help_get', params)
  },
  help_list: params => {
    return API.POST('/manager/pc/help_list', params)
  },
  del_help: params => {
    return API.POST('/manager/pc/del_help', params)
  },
  edit_pass: params => {
    return API.POST('/manager/user/pc/edit_pass', params)
  },
  dashboard: params => {
    return API.POST('/manager/user/pc/dashboard', params)
  },


  status_good_postage: params => {
    return API.POST('/manager/user/pc/status_good_postage', params)
  },
  up_add_good_postage: params => {
    return API.POST('/manager/user/pc/up_add_good_postage', params)
  },
  good_postage_list: params => {
    return API.POST('/manager/user/pc/good_postage_list', params)
  },

  //
  good_property_list: params => {
    return API.POST('/manager/user/pc/good_property_list', params)
  },
  //
  add_good_property: params => {
    return API.POST('/manager/user/pc/add_good_property', params)
  },
  //
  del_good_property: params => {
    return API.POST('/manager/user/pc/del_good_property', params)
  },

  good_sku_list: params => {
    return API.POST('/manager/user/pc/good_sku_list', params)
  },
  add_good_sku: params => {
    return API.POST('/manager/user/pc/add_good_sku', params)
  },
  up_good_sku: params => {
    return API.POST('/manager/user/pc/up_good_sku', params)
  },
  status_good_sku: params => {
    return API.POST('/manager/user/pc/status_good_sku', params)
  },


  service_type_list: params => {
    return API.POST('/manager/user/pc/service_type_list', params)
  },
  add_service_type: params => {
    return API.POST('/manager/user/pc/add_service_type', params)
  },
  del_service_type: params => {
    return API.POST('/manager/user/pc/del_service_type', params)
  },
  push_service_type: params => {
    return API.POST('/manager/user/pc/push_service_type', params)
  },
  down_service_type: params => {
    return API.POST('/manager/user/pc/down_service_type', params)
  },

  stu_course_type_list: params => {
    return API.POST('/manager/user/pc/stu_course_type_list', params)
  },
  add_stu_course_type: params => {
    return API.POST('/manager/user/pc/add_stu_course_type', params)
  },
  del_stu_course_type: params => {
    return API.POST('/manager/user/pc/del_stu_course_type', params)
  },
  push_stu_course_type: params => {
    return API.POST('/manager/user/pc/push_stu_course_type', params)
  },
  down_stu_course_type: params => {
    return API.POST('/manager/user/pc/down_stu_course_type', params)
  },
  user_pc_stock_control: params => {
    return API.POST('/manager/user/pc/stock_control',params)
  },
  company_stock_list: params => {
    return API.POST('/manager/user/pc/company_stock_list', params)
  },
  wait_send_list: params => {
    return API.POST('/manager/user/pc/wait_send_list', params)
  },
  stock_change_list: params => {
    return API.POST('/manager/user/pc/stock_change_list', params)
  },
  fake_num_change_list: params => {
    return API.POST('/manager/user/pc/fake_num_change_list', params)
  },
  normal_user_stock_list: params => {
    return API.POST('/manager/user/pc/normal_user_stock_list', params)
  },
  add_stock: params => {
    return API.POST('/manager/user/pc/add_stock', params)
  },
  add_user_stock: params => {
    return API.POST('/manager/user/pc/add_user_stock', params)
  },
  list_good_name: params => {
    return API.POST('/manager/user/pc/list_good_name', params)
  },

  manager_user_money: params => {
    return API.GET('/manager/user/money',params)
  },
  manager_user_money_moneyAll: params => {
    return API.GET("/manager/user/money/moneyAll",params)
  },

  android_version_list: params => {
    return API.POST('/manager/user/pc/android_version_list', params)
  },
  del_android_version: params => {
    return API.POST('/manager/user/pc/del_android_version', params)
  },
  add_android_version: params => {
    return API.POST('/manager/user/pc/add_android_version', params)
  },

  direct_in_list: params => {
    return API.POST('/manager/user/pc/direct_in_list', params)
  },
  wait_bu_list: params => {
    return API.POST('/manager/user/pc/wait_bu_list', params)
  },
  year_in_list: params => {
    return API.POST('/manager/user/pc/year_in_list', params)
  },

  year_in_list1: params => {
    return API.POST('/manager/user/pc/year_in_list1', params)
  },

  up_direct_watch: params => {
    return API.POST('/manager/user/pc/up_direct_watch', params)
  },
  stu_course_list: params => {
    return API.POST('/manager/user/pc/stu_course_list', params)
  },
  add_edit_stu_course: params => {
    return API.POST('/manager/user/pc/add_edit_stu_course', params)
  },
  del_stu_course: params => {
    return API.POST('/manager/user/pc/del_stu_course', params)
  },

  change_watch_info: params => {
    return API.POST('/manager/user/pc/change_watch_info', params)
  },

  statue_direct_watch: params => {
    return API.POST('/manager/user/pc/statue_direct_watch', params)
  },

  push_stu_course: params => {
    return API.POST('/manager/user/pc/push_stu_course', params)
  },
  down_stu_course: params => {
    return API.POST('/manager/user/pc/down_stu_course', params)
  },

  direct_watch_list: params => {
    return API.POST('/manager/user/pc/direct_watch_list', params)
  },

  course_user_msg_list: params => {
    return API.POST('/manager/user/pc/course_user_msg_list', params)
  },

  integral_change_balance: params => {
    return API.POST('/manager/user/pc/integral_change_balance', params)
  },
  out_risk_m: params => {
    return API.POST('/manager/user/pc/out_risk_m', params)
  },
  risk_op_list: params => {
    return API.POST('/manager/user/pc/risk_op_list', params)
  },

  user_integral_history_list: params => {
    return API.POST('/manager/user/pc/user_integral_history_list', params)
  },

  goodPriceData: params => {
    return API.POST('/manager/user/pc/goodPriceData', params)
  },

  shopRecordList: params => {
    return API.POST('/manager/user/pc/shopRecordList', params)
  },

  userTransferHistoryList: params => {
    return API.POST('/manager/user/pc/userTransferHistoryList', params)
  },
  editShopRecordStatus: params => {
    return API.POST('/manager/user/pc/editShopRecordStatus', params)
  },
  select_store_pc: params => {
    return API.POST('/manager/user/pc/select_store_pc', params)
  },


  area_info_list: params => {
    return API.POST('/manager/user/pc/area_info_list', params)
  },
  add_up_area_info: params => {
    return API.POST('/manager/user/pc/add_up_area_info', params)
  },
  di_give_money: params => {
    return API.POST('/manager/user/pc/di_give_money', params)
  },
  code_give_check: params => {
    return API.POST('/manager/user/pc/code_give_check', params)
  },
  status_area_info: params => {
    return API.POST('/manager/user/pc/status_area_info', params)
  },

  good_series_list: params => {
    return API.POST('/manager/user/pc/good_series_list', params)
  },
  up_add_good_series: params => {
    return API.POST('/manager/user/pc/up_add_good_series', params)
  },
  status_good_series: params => {
    return API.POST('/manager/user/pc/status_good_series', params)
  },
  apply_good_list: params => {
    return API.POST('/manager/user/pc/apply_good_list', params)
  },
  up_activity: params => {
    return API.POST('/manager/user/pc/up_activity', params)
  },
  activity_list: params => {
    return API.POST('/manager/user/pc/activity_list', params)
  },
  up_activity_status: params => {
    return API.POST('/manager/user/pc/up_activity_status', params)
  },

  activity_user_list: params => {
    return API.POST('/manager/user/pc/activity_user_list', params)
  },
  up_activity_user_good_num: params => {
    return API.POST('/manager/user/pc/up_activity_user_good_num', params)
  },
  up_activity_user_good_num_new: params => {
    return API.POST('/manager/user/pc/up_activity_user_good_num_new', params)
  },
  activity_user_num_history_list: params => {
    return API.POST('/manager/user/pc/activity_user_num_history_list', params)
  },
  activity_count_info: params => {
    return API.POST('/manager/user/pc/activity_count_info', params)
  },

  getOperationList: params => {
    return API.POST('/manager/user/pc/getOperationList', params)
  },

  error_log_list: params => {
    return API.POST('/manager/user/pc/error_log_list', params)
  },


  t_r_send_identify: params => {
    return API.POST('/manager/user/pc/t_r_send_identify', params)
  },
  t_check_pay_identify: params => {
    return API.POST('/manager/user/pc/t_check_pay_identify', params)
  },
  get_companyInfo: params => {
    return API.POST('/manager/user/pc/get_companyInfo', params)
  },
  tong_code: params => {
    return API.POST('/manager/user/pc/tong_code', params)
  },
  user_bind_tel: params => {
    return API.POST('/manager/user/pc/user_bind_tel', params)
  },
  set_company_info: params => {
    return API.POST('/manager/user/pc/set_company_info', params)
  },
  idcardCollect: params => {
    return API.POST('/manager/user/pc/idcardCollect', params)
  },
  get_sign_url: params => {
    return API.POST('/manager/user/pc/get_sign_url', params)
  },


  export_log_list: params => {
    return API.POST('/manager/user/pc/export_log_list', params)
  },
  integral_history_list: params => {
    return API.POST('/manager/user/pc/integral_history_list', params)
  },
  deposit_history_list: params => {
    return API.POST('/manager/user/pc/deposit_history_list', params)
  },
  send_score_history_list: params => {
    return API.POST('/manager/user/pc/send_score_history_list', params)
  },
  up_user_send_score: params => {
    return API.POST('/manager/user/pc/up_user_send_score', params)
  },


  //提现黑名单列表
  out_black_list: params => {
    return API.POST('/manager/user/pc/out_black_list', params)
  },
  //新增黑名单
  up_out_black: params => {
    return API.POST('/manager/user/pc/up_out_black', params)
  },
  //修改黑名单状态
  up_out_black_status: params => {
    return API.POST('/manager/user/pc/up_out_black_status', params)
  },

}



// WEBPACK FOOTER //
// ./src/api/api_user.js